import axios from 'axios';
import { baseUrl, HttpMethods } from '@/api/base';

export async function getApplicationTeamMembers({
  applicationId,
}: IGetApplicationTeamMembersService): Promise<IGetApplicationTeamMembersServiceRes> {
  const res = await axios.request<IGetApplicationTeamMembersServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/applications/${applicationId}/users`,
  });
  return res.data;
}

export async function addApplicationTeamMember({ data, applicationId }: IPostApplicationTeamMemberService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.ROVER}/applications/${applicationId}/users`,
    data,
  });
  return res.data;
}

export async function removeApplicationTeamMember({ applicationId, userId }: IDeleteApplicationTeamMemberService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.ROVER}/applications/${applicationId}/users/${userId}`,
  });
  return res.data;
}

export async function addTempLead({ applicationId, userId }: IAddTempLeadApplicationTeamMemberService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.ROVER}/applications/${applicationId}/users/${userId}`,
  });
  return res.data;
}

export async function removeTempLead({ applicationId, userId }: IRemoveTempLeadApplicationTeamMemberService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.ROVER}/applications/${applicationId}/users/${userId}/remove`,
  });
  return res.data;
}
